export const getItem = (name) => {
  return localStorage.getItem(name);
};

export const setItem = (name, data) => {
  return localStorage.setItem(name, data);
};

export const getSessionInfo = () => {
  const expireDate = "expirationDate";
  const currentTime = new Date().getTime();
  const durationTimeDifference = getItem(expireDate) - currentTime;
  return {
    isFinished: durationTimeDifference <= 0,
    timeDuration: getItem(expireDate) ? durationTimeDifference : 0,
  };
};

export const setTimeoutExpire = (cb) => {
  setTimeout(() => {
    cb();
  }, getSessionInfo().timeDuration);
};
